import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

const ROLES = ['user', 'doctor', 'admin'];

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  const load = () => api.get(`/admin/users${q ? `?q=${encodeURIComponent(q)}` : ''}`).then(({ data }) => setUsers(data));
  useEffect(() => { load(); }, [q]);

  const updateRole = async (uid, role) => {
    try { await api.put(`/admin/users/${uid}/role`, { role }); toast.success('Role updated'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Users</h1>
          <p className="text-sans_mute mt-2">Search and manage patient / doctor / admin roles.</p>
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search email or name…" className="border border-sans_line bg-white px-3 py-2 text-sm w-64" />
      </div>
      <div className="mt-8 bg-white border border-sans_line overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-sans_line">
            {['Name', 'Email', 'Role', 'Provider', 'Joined'].map((h) => <th key={h} className="text-left px-4 py-3 font-medium text-[11px] tracking-[0.18em] uppercase text-sans_mute">{h}</th>)}
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-sans_line hover:bg-sans_bone/50">
                <td className="px-4 py-3 text-sans_ink">{u.name}</td>
                <td className="px-4 py-3 text-sans_mute">{u.email}</td>
                <td className="px-4 py-3">
                  <select value={u.role || 'user'} onChange={(e) => updateRole(u.user_id, e.target.value)} className="border border-sans_line px-2 py-1 text-sm bg-white">
                    {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-sans_mute">{u.provider || 'email'}</td>
                <td className="px-4 py-3 text-sans_mute text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString('en-IN') : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminUsers;
